module.exports = __webpack_public_path__ + "img/veriety_mt.44657cfe.png";